import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from '../../../components/JSModal';
import { tutorialOpacity } from 'shared/utils/tutorial';
import { generateTutorialInfoScreen } from 'shared/screens/Missions/utils/generateMissionRendering';
import { sendMissionsEvent } from 'shared/screens/Missions/analytics/missionsLogger';
import { EVENT_TYPES } from 'shared/lib/analytics/constants';

const MissionHelp = ({ activeTutorial, missionsAssets }) => {
  const [openModal, setOpenModal] = useState(false);
  const [tutorialScreen, setTutorialScreen] = useState(null);

  const handleOpenModal = () => {
    sendMissionsEvent(EVENT_TYPES.MISSIONS_OPEN_INFO_SCREEN);
    setTutorialScreen(missionsAssets.TUTORIAL_INFO_SCREEN_STEP_1);
    setOpenModal(true);
  };

  const findIndexScreen = () => generateTutorialInfoScreen(missionsAssets).findIndex(x => x === tutorialScreen);
  const handleBackScreen = () => setTutorialScreen(generateTutorialInfoScreen(missionsAssets)[findIndexScreen() - 1]);
  const handleFowardScreen = () => setTutorialScreen(generateTutorialInfoScreen(missionsAssets)[findIndexScreen() + 1]);

  return (
    <Wrapper disabled={activeTutorial}>
      <HelpContainer>
        <div onClick={() => handleOpenModal()}>
          <HelpImage src={missionsAssets.TUTORIAL_INFO_BUTTON} />
        </div>
      </HelpContainer>
      <Modal
        style={modalStyle}
        modalBodyStyle={modalBodyStyle}
        isVisible={openModal}
        hideDefaultBackground
        hideCloseButton
      >
        <ModalContainer>
          <Image src={tutorialScreen} />
          <CloseButton onClick={() => setOpenModal(!openModal)}>
            <Image src={missionsAssets.TUTORIAL_INFO_SCREEN_CLOSE_BTN} />
          </CloseButton>
          <BackButton indexScreen={findIndexScreen()} onClick={() => handleBackScreen()}>
            <Image src={missionsAssets.TUTORIAL_INFO_SCREEN_ARROW} />
          </BackButton>
          <ForwardButton indexScreen={findIndexScreen()} onClick={() => handleFowardScreen()}>
            <Image src={missionsAssets.TUTORIAL_INFO_SCREEN_ARROW} />
          </ForwardButton>
        </ModalContainer>
      </Modal>
    </Wrapper>
  );
};

export default MissionHelp;

const modalStyle = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6vh 16vw 0',
  zIndex: '10',
};

const modalBodyStyle = {
  padding: '0',
};

const Wrapper = styled.div`
  z-index: 5;
  opacity: ${({ disabled }) => tutorialOpacity(disabled)};
`;

const HelpContainer = styled.div`
  position: absolute;
  flex: 1;
  z-index: 5;
  top: 5.3rem;
  left: 1rem;
`;

const HelpImage = styled.img`
  cursor: pointer;
  height: 3.6rem;
  width: 3.6rem;
`;

const ModalContainer = styled.div`
  width: 100%;
`;

const Image = styled.img`
  position: relative;
  width: 100%;
`;

const CloseButton = styled.div`
  position: absolute;
  width: 13vh;
  top: -4.5%;
  right: -4vh;
`;

const BackButton = styled.div`
  position: absolute;
  width: 13vh;
  top: 43%;
  left: -6.5vh;
  display: ${({ indexScreen }) => (indexScreen === 0 ? 'none' : 'block')};
`;

const ForwardButton = styled.div`
  position: absolute;
  width: 13vh;
  top: 43%;
  right: -6.5vh;
  transform: rotateY(180deg);
  display: ${({ indexScreen }) => (indexScreen === 2 ? 'none' : 'block')};
`;

